jQuery(document).ready(function($) {

  /**
   *
   * ACTIONS - LISTENERS
   *
   */

	//Search mixture listener
	$('.js-mixtures-filter').submit(function (e) { 
		e.preventDefault();
    search = $('.js-mixtures-search').val();
    start_with = $('.js-mixtures-alphabet span.active').text();

    filterMixtures(search,start_with);
	});

	//start with alphabet listener {
	$('.js-mixtures-alphabet span').click(function (e) { 
    start_with = $(this).text();
    $('.js-mixtures-alphabet span').removeClass('active');
    $(this).addClass('active');
    search = $('.js-mixtures-search').val(); //zohlednit hledání
    
		filterMixtures(search, start_with);
  });
  
  //reset filter
  $('.js-mixtures-filter .fullwsearching__reset').click(function (e) { 
    e.preventDefault();
    $('.js-mixtures-alphabet span').removeClass('active');
    $('.js-mixtures-search').removeClass('active').val('');
    filterMixtures('', '');
  });



  /**
   *
   * AJAX - SEARCHING
   *
   */

		/* MIXTURE SEARCHING */
	function filterMixtures(search = '', start_with = '') {

    if(search.length == 0) {
			search = '';
    }
    
    if(start_with.length == 0) {
			start_with = '';
    }
    
    if(search.length == 0 && start_with.length == 0) {
      $('.fullwsearching__reset').removeClass('fullwsearching__reset--active'); //remove reset button
    } else {
      $('.fullwsearching__reset').addClass('fullwsearching__reset--active'); //add reset button
    }

		params = {};
		params.search = search;
    params.start_with = start_with;
    
    $('.fullwsearching__submit').addClass('button-loading').attr('disabled','disabled');
    

		var ajaxUrl =  '/wp-admin/admin-ajax.php';
		$.post(ajaxUrl, {
        action:"filterMixtures_ajax",
        data: params,
        dataType: "json",
		contentType : "application/json;charset=utf-8",
    }).done(function(result_json){
        if(result_json.length) {
					result = jQuery.parseJSON(result_json);
					$('.js-mixtures-list').html(result);
        	//console.log(result);
        }
        $('.fullwsearching__submit').removeClass('button-loading').removeAttr('disabled');
    });
	}


});